import * as React from 'react';
import { FastField, FieldProps } from 'formik';

interface IInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  secondary?: boolean;
  small?: boolean;
}

export const getInputClass = ({
  secondary = false,
  className = '',
  type = 'text',
  disabled = false,
  small = false,
}: IInputProps) => {
  if (type === 'checkbox') {
    return '';
  }
  const base = `${
    disabled ? 'opacity-50' : ''
  } leading-tight rounded-lg focus:outline-none focus:shadow-outline`;
  return secondary
    ? `${base} bg-grey ${small ? 'px-3 py-2' : 'px-4 py-3'} ${className}`
    : `${base} bg-white shadow px-3 py-2 ${className}`;
};

export const Input = ({
  small,
  secondary,
  name,
  className,
  type = 'text',
  ...props
}: IInputProps) => (
  <input
    type={type}
    name={name}
    id={name}
    className={getInputClass({
      small,
      secondary,
      className,
      type,
      disabled: props.disabled,
    })}
    {...props}
  />
);

const renderFormInput = (props: IInputProps) => ({
  field: { value, ...fieldProps },
}: FieldProps<any>) => <Input value={value || ''} {...fieldProps} {...props} />;

export const FormInput = ({ name, ...props }: IInputProps) => (
  <FastField name={name} render={renderFormInput(props)} />
);



// WEBPACK FOOTER //
// ./src/components/Form/Input.tsx